module.exports = __webpack_public_path__ + "img/logo.30e093a7.png";